"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _excluded = ["infoid", "sectionid", "sortname", "sortid", "url", "other", "areaexposure", "isdot", "metric", "info", "goodsexposure", "legoareabackup"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function setAttributes(element, attrs) {
  Object.keys(attrs).forEach(function (key) {
    if (attrs[key] !== undefined && attrs[key] !== null && attrs[key] !== '') {
      element.setAttribute(key, attrs[key]);
    }
  });
}
var callback = function callback(el, binding) {
  var _binding$value = binding.value,
    _binding$value$infoid = _binding$value.infoid,
    infoid = _binding$value$infoid === void 0 ? '' : _binding$value$infoid,
    _binding$value$sectio = _binding$value.sectionid,
    sectionid = _binding$value$sectio === void 0 ? '' : _binding$value$sectio,
    _binding$value$sortna = _binding$value.sortname,
    sortname = _binding$value$sortna === void 0 ? '' : _binding$value$sortna,
    _binding$value$sortid = _binding$value.sortid,
    sortid = _binding$value$sortid === void 0 ? '' : _binding$value$sortid,
    _binding$value$url = _binding$value.url,
    url = _binding$value$url === void 0 ? '' : _binding$value$url,
    _binding$value$other = _binding$value.other,
    other = _binding$value$other === void 0 ? '' : _binding$value$other,
    _binding$value$areaex = _binding$value.areaexposure,
    areaexposure = _binding$value$areaex === void 0 ? '' : _binding$value$areaex,
    _binding$value$isdot = _binding$value.isdot,
    isdot = _binding$value$isdot === void 0 ? '' : _binding$value$isdot,
    _binding$value$metric = _binding$value.metric,
    metric = _binding$value$metric === void 0 ? '' : _binding$value$metric,
    _binding$value$info = _binding$value.info,
    info = _binding$value$info === void 0 ? '' : _binding$value$info,
    _binding$value$goodse = _binding$value.goodsexposure,
    goodsexposure = _binding$value$goodse === void 0 ? '' : _binding$value$goodse,
    _binding$value$legoar = _binding$value.legoareabackup,
    legoareabackup = _binding$value$legoar === void 0 ? '' : _binding$value$legoar,
    backup = _objectWithoutProperties(_binding$value, _excluded);
  var zpm_attrs = {
    'zz-infoid': infoid,
    'zz-sectionid': sectionid,
    'zz-sortid': sortid,
    'zz-sortname': sortname,
    'zz-url': url,
    'zz-other': other,
    'data-areaexposure': areaexposure,
    'lego-goods-exposure': goodsexposure ? JSON.stringify(goodsexposure) : '',
    'data-isdot': isdot,
    'data-metric': metric,
    'data-info': info ? JSON.stringify(info) : '',
    'zz-backup': backup && Object.keys(backup).length ? JSON.stringify(backup) : '',
    'lego-area-backup': legoareabackup ? JSON.stringify(legoareabackup) : ''
  };
  setAttributes(el, zpm_attrs);
};
var zpm = function zpm() {
  _vue.default.directive('zpm', {
    bind: callback,
    update: callback
  });
};
var _default = zpm;
exports.default = _default;